export class PageStart {
    constructor() {
        this.showHideElements();
        window.addEventListener('resize', this.showHideElements);
        window.addEventListener('orientationchange', this.showHideElements);
    }
    showHideElements() {
        if (window.innerWidth <= 800) {
            document.body.classList.remove('desktop-view');
            document.body.classList.add('mobile-view');
        }
        else {
            document.body.classList.remove('mobile-view');
            document.body.classList.add('desktop-view');
        }
    }
}
